import { useCallback, useEffect, useState } from "react";
import App from "@/App";
import Login from "@/Login";
import { api } from "@/lib/marsheeApi";

// null = checking, false = unauthenticated, object = authenticated owner
export default function AuthGate() {
  const [auth, setAuth] = useState(null);

  const check = useCallback(async () => {
    try {
      const user = await api.me();
      setAuth(user);
      return true;
    } catch (e) {
      setAuth(false);
      return false;
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const handleLogout = async () => {
    try { await api.logout(); } catch (e) { /* clear locally regardless */ }
    setAuth(false);
  };

  if (auth === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-checking" style={{ backgroundColor: "#241D18" }}>
        <p className="mh-sans" style={{ color: "#8C7B6C", fontSize: "0.95rem" }}>Unlocking…</p>
      </div>
    );
  }

  if (!auth) {
    return <Login onSuccess={check} />;
  }

  return <App onLogout={handleLogout} />;
}
